import { Controller } from "@hotwired/stimulus"
import moment from "moment"

export default class extends Controller {
  static get targets() {
    return ["display", "hidden"]
  }

  static get values() {
    return {
      initial: String
    }
  }

  connect() {
    const initialValue = this.initialValue || ""
    this.hiddenTarget.value = initialValue
    this.displayTarget.value = this.formatForInput(initialValue)
  }

  sync() {
    if (!this.displayTarget.value) {
      this.hiddenTarget.value = ""
      return
    }

    const parsed = moment(this.displayTarget.value, "YYYY-MM-DDTHH:mm", true)
    this.hiddenTarget.value = parsed.isValid() ? parsed.toISOString() : this.displayTarget.value
  }

  formatForInput(value) {
    const parsed = moment(value)
    return parsed.isValid() ? parsed.format("YYYY-MM-DDTHH:mm") : ""
  }
}
